import React from 'react';

const Footer = () => (
  <footer className="text-center py-3 mt-4 bg-light shadow-sm">
    <small>&copy; 2025 Kamsiparts Admin Dashboard</small>
  </footer>
);

export default Footer;
